export const ClassNames = {
	icon: 'c-HiddenImageIcon',
	position: {
		center: 'c-HiddenImageIcon-center',
		topLeft: 'c-HiddenImageIcon-left',
		topRight: 'c-HiddenImageIcon-right',
		bottomLeft: 'c-HiddenImageIcon-top',
		bottomRight: 'c-HiddenImageIcon-bottom',
	},
} as const;

export const Style = {
	[ClassNames.icon]: {
		'font-size': '36px',
		color: 'white',
		'text-shadow': `0 6px 10px rgba(0, 0, 0, .14),
             0 1px 18px rgba(0, 0, 0, .12),
             0 3px 5px rgba(0, 0, 0, .2);`,
		position: 'absolute',
	},
	[ClassNames.position.center]: {
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
	},
	[ClassNames.position.topLeft]: {
		top: '0%',
		left: '0%',
	},
	[ClassNames.position.topRight]: {
		top: '0%',
		left: '100%',
		transform: 'translate(-100%, 0%)',
	},
	[ClassNames.position.bottomLeft]: {
		top: '100%',
		left: '0%',
		transform: 'translate(0%, -100%)',
	},
	[ClassNames.position.bottomRight]: {
		top: '100%',
		left: '100%',
		transform: 'translate(-100%, -100%)',
	},
};
